import { ENDPOINTS } from '../_config';

export const getSoftwares = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_SOFTWARES);
    const response = await request.json();

    return response;
  } catch (e) {
    return null;
  }
};
